import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { getBreakpointFromManor } from 'ctm-components';

import { GetInTouch } from '../../products/products/common/get_in_touch';
import { withQuoteFlatten, QuoteFlattenType } from '../../products/products/common/with_quote_flatten';

const useStyles = createUseStyles((theme) => ({
    container: {
        backgroundColor: theme.colors.white,
        padding: {
            right: '0.8rem',
            left: '0.8rem'
        },
        marginTop: '0.8rem',
        marginBottom: '2rem'
    },
    getInTouch: {
        marginBottom: 0
    },
    getIntouchButtonXs: {
        fontSize: theme.fontSize.xs
    }
}));

const _ProductIntroCardTouch = (props) => {
    const breakpoint = getBreakpointFromManor();
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { className, quote } = props;

    return (
        <div className={classNames('test-policyComparison-productIntroCard-touch', classes.container, className)}>
            <GetInTouch
                className={classes.getInTouch}
                quote={quote}
                buttonClassName={breakpoint === 'xs' ? classes.getIntouchButtonXs : undefined}
            />
        </div>
    );
};

_ProductIntroCardTouch.propTypes = {
    className: PropTypes.string,

    quote: PropTypes.object.isRequired

};

const ProductIntroCardTouch = withQuoteFlatten(_ProductIntroCardTouch);

export { ProductIntroCardTouch };
